import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { toast } from "sonner";

const LOGO_STYLE = { backgroundImage: "url('/logo.png')", backgroundSize: "205% auto", backgroundPosition: "center 5%", backgroundRepeat: "no-repeat" };

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-20">
      <div className="text-center mb-8">
        <span className="inline-block w-16 h-16 rounded-2xl bg-white shadow-sm ring-1 ring-blue-900/10 mx-auto mb-4" style={LOGO_STYLE} />
        <h1 className="font-display text-3xl font-bold text-blue-950 dark:text-blue-50">Sign in to T5 Care</h1>
        <p className="mt-2 text-slate-600 dark:text-slate-300">Access your courses, downloads and care requests.</p>
      </div>
      <form onSubmit={submit} data-testid="login-form" className="bg-white dark:bg-blue-900/30 rounded-2xl p-8 shadow-lg border border-blue-900/5 space-y-4">
        {error && <div data-testid="login-error" className="bg-red-50 text-red-700 text-sm rounded-lg px-4 py-2.5">{error}</div>}
        <div><Label htmlFor="l-email">Email</Label><Input id="l-email" type="email" data-testid="login-email-input" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" /></div>
        <div><Label htmlFor="l-pw">Password</Label><Input id="l-pw" type="password" data-testid="login-password-input" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" /></div>
        <Button type="submit" disabled={loading} data-testid="login-submit-button" className="w-full h-12 bg-blue-900 hover:bg-blue-950 text-white">
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Sign In"}
        </Button>
        <p className="text-center text-sm text-slate-500">No account? <Link to="/register" data-testid="go-register-link" className="text-blue-800 dark:text-blue-300 font-medium">Create one</Link></p>
      </form>
    </div>
  );
}
